module.exports = __webpack_public_path__ + "static/img/z1.2a259a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/association/z1.png
// module id = uq9X
// module chunks = 2